export abstract class IHttpAuthHandler {
  abstract silentAuthenticate(): Promise<void>;
  abstract handleAuthFailure(): void;
}
